$(document).ready(function () {
    // Проверка: запускаем только в Chrome
    const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    if (!isChrome) return;

    const $anchors = $('a[href^="#"]');
    if (!$anchors.length) return;

    const $header = $('header');
    const headerHeight = $header.length ? $header.outerHeight() : 0;

    const $scrollElement = $('html, body'); 

    $anchors.on('click', function (e) {
        const href = $(this).attr('href');
        if (!href || href === "#") return;

        const $target = $(href);
        if (!$target.length) return;

        e.preventDefault();
        $scrollElement.stop().animate({
            scrollTop: $target.offset().top - headerHeight
        }, 800);
    });
});
